import React, { useReducer, useEffect } from 'react'

import AuthContext from './AuthContext';
import authReducer from './authReducer';

export default function AuthProvider({ children }) {

	const DEFAULT_STATE = {
		user: {},
		loggedIn: false
	}

	// Checks if user exists in local storage, if not render intial state.
	const checkStorageForUser = () => {

		if ( typeof window === 'undefined' ) {
			return DEFAULT_STATE;
		}

		const user = JSON.parse( localStorage.getItem( 'user' ) ) ? JSON.parse( localStorage.getItem( 'user' ) ) : DEFAULT_STATE;
		
		return user;
	};

	useEffect(() => {
		checkStorageForUser()
	})

	return (
		<AuthContext.Provider value={ useReducer( authReducer, checkStorageForUser() ) }>
			{children}
		</AuthContext.Provider>
	)
}
